import { useEffect, useState, useMemo } from 'react';
import cx from 'classnames';
import dynamic from 'next/dynamic';

import { eventGtag } from '#app/hooks/eventGtag';
import { useUserContext } from '#hooks/index';

import styles from './index.module.scss';

const Typography = dynamic(() => import('#app/UI/atoms/typography-updated'));
const Dropdown = dynamic(() => import('./dropdown'));

const filterProducts = (products, currentAge) => {
  try {
    if (!products.length) {
      const keys = Object.keys(products);
      const res = {};

      keys.forEach(item => {
        res[item] = products?.[item].filter(
          product => Object.keys(product)[0] === currentAge.key
        )[0][currentAge.key];
      });

      return res;
    } else {
      return products?.filter(product => Object.keys(product)[0] === currentAge.key)[0][
        currentAge.key
      ];
    }
  } catch (e) {
    return [];
  }
};

const Ages = ({
  isDesktop,
  ages,
  list,
  setCurrentList,
  className,
  backgroundColor,
  eventNameAnalytics,
  currency,
  type = 'course'
}) => {
  const { data: userData } = useUserContext();
  const initialCurrentAge = useMemo(
    () => ({
      key: Object.keys(ages ? ages[0] : '')[0],
      text: 'Ver todas'
    }),
    [ages]
  );
  const [currentAge, setCurrentAge] = useState(initialCurrentAge);

  useEffect(() => {
    setCurrentAge({
      key: Object.keys(ages ? ages[0] : '')[0],
      text: 'Ver todas'
    });

    return () => {
      setCurrentList(null);
    };
  }, [currency, ages]);

  useEffect(() => {
    setCurrentList(filterProducts(list, currentAge));

    return () => {
      setCurrentList(null);
    };
  }, [currentAge]);

  return (
    <section className={styles.wrapper}>
      <div className={cx(className, styles.container)}>
        {/* Text */}
        <div className={styles.text}>
          <Typography tag={isDesktop ? 'h3' : 'body-small'}>Edades:</Typography>
        </div>

        {isDesktop ? (
          <ul className={styles.list}>
            {ages ? (
              <>
                {ages.map((age, idx) => {
                  const first = age[Object.keys(age)[0]][0];
                  const last =
                    age[Object.keys(age)[0]][age[Object.keys(age)[0]].length - 1];

                  const text =
                    `${first} - ${last}` === '5 - 18'
                      ? 'Ver todos'
                      : `${first} - ${last}` === '16 - 18'
                      ? '16+'
                      : `${first} - ${last}`;

                  return (
                    <li
                      key={idx}
                      className={cx(
                        styles.item,
                        {
                          [styles.item__active]:
                            currentAge.key === Object.keys(age)[0] && type === 'course'
                        },
                        {
                          [styles.item__path_active]:
                            currentAge.key === Object.keys(age)[0] && type === 'path'
                        }
                      )}
                      onClick={() => {
                        setCurrentList(null);
                        if (currentAge.key === Object.keys(age)[0]) {
                          setCurrentAge({
                            key: 'all',
                            text: 'Ver todos'
                          });
                        } else {
                          setCurrentAge({
                            key: Object.keys(age)[0],
                            text
                          });
                        }
                        eventGtag(eventNameAnalytics, userData, {age_selected_filter: text});
                      }}
                    >
                      <Typography tag="body-small">{text}</Typography>
                    </li>
                  );
                })}
              </>
            ) : (
              <li
                className={cx(
                  styles.item,
                  { [styles.item__active]: type === 'course' },
                  { [styles.item__path_active]: type === 'path' }
                )}
                onClick={() => {
                  setCurrentList(null);
                  if (currentAge.key === Object.keys(age)[0]) {
                    setCurrentAge({
                      key: 'all',
                      text: 'Ver todos'
                    });
                  }
                  eventGtag(eventNameAnalytics, userData, {age_selected_filter: 'Ver todos'});
                }}
              >
                <Typography tag="body-small">Ver todos</Typography>
              </li>
            )}
          </ul>
        ) : (
          <Dropdown
            list={ages}
            currentAge={currentAge}
            handleSetCurrentAge={setCurrentAge}
            type={type}
          />
        )}
      </div>
    </section>
  );
};

export default Ages;
